<template>
	<div id="content">
        <div id="box">
		    <shutter-panel ref="shutterPanel" />
        </div>
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'StallionCampagneNotClosed',
		mixins: [ShutterCongelation],
		mounted() {
			this.setUpCampagneStallionListeNotClosed()
		},
	}
</script>